
import React, { useCallback, useEffect, useState } from 'react';
import moment from "moment";
import { DayPicker } from 'react-day-picker';
import en from 'date-fns/locale//en-US';
import fr from 'date-fns/locale/fr';
import ru from 'date-fns/locale/ru';
import styles from './CustomDayPicker.module.scss';
import 'react-day-picker/dist/style.css';
import { useTranslation } from 'next-i18next';
import { Checkbox, FormControlLabel } from '@mui/material';

function CustomDayPicker(props) {
  const [showPicker, setShowPicker] = useState(false);
  const [mode, setMode] = useState('range');
  const { t, i18n } = useTranslation();
  const handleChangeMode = useCallback(() => mode === 'range' ? setMode('single') : setMode('range'), [mode]);
  moment.locale(i18n.language);
  useEffect(() => {
    if (mode === "single") {
      props?.setSelected(props?.selected.from);
    }
  }, [mode, props?.selected]);
  return (
    <>
      <div className={styles.custom_picker}>
        {showPicker && <div onClick={() => setShowPicker(false)} className={styles.close}>x</div>}
        <div className={`d-flex gap-2 ${styles.inputCont}`}>
          <input
            placeholder={t("date")}
            type='text'
            value={props?.selected?.from && props?.selected?.to
              ? `${moment(props?.selected?.from).format('DD MMM')} - ${moment(props?.selected?.to).format('DD MMM')}`
              : (props?.selected?.from ? `${moment(props?.selected?.from).format('DD MMM')}` : '')
            }
            onFocus={() => setShowPicker(true)}
          // onBlur={() => setShowPicker(false)}
          />
          { props.selected.from && <span onClick={() => {
                        props.setSelected({
                            from: '',
                            to: ''
                        })
                    }} className={styles.closeIcon}>x</span>}
          {/* <FormControlLabel control={
            <Checkbox
              checked={mode === 'single'}
              onChange={handleChangeMode}

            />}
            label={t('oneDay')}
          /> */}
        </div>
        {showPicker && <div className={styles.day_picker_cont}>
          <DayPicker
            mode={mode}
            selected={mode === "single" && props?.selected.from ? props?.selected.from : props?.selected}
            onSelect={(v) => {
              props?.setSelected(v);
            }}
            weekStartsOn={1}
            locale={i18n.language === 'ru' ? ru : i18n.language === 'fr' ? fr : en}
          />
        </div>}
      </div>
      {showPicker && <div onClick={() => setShowPicker(false)} className={styles.custom_picker_layer}></div>}
    </>
  );
}
export default CustomDayPicker;